// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(.rich-text-viewer--with-files) .despacho-box {
  margin-bottom: 0;
}

.despacho-box {
  background-color: var(--app-slate-100);
  border-radius: 6px;
  padding: 4px 8px;
  margin-top: 2px;
  margin-bottom: 4px;
}

.rich-text-viewer-value {
  display: flow-root;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.rich-text-viewer-value ::ng-deep p {
  margin: 0;
}

.rich-text-viewer-value ::ng-deep ul,
.rich-text-viewer-value ::ng-deep ol {
  margin: 0;
  padding-left: 1.2em;
}

.rich-text-viewer--despacho .rich-text-viewer-value ::ng-deep ul,
.rich-text-viewer--despacho .rich-text-viewer-value ::ng-deep ol {
  padding: 0 0 0 1em;
}

.despacho-preview::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 35px;
  background: linear-gradient(to bottom, transparent, var(--app-slate-100));
  pointer-events: none;
}

.ver-mais-link {
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  color: var(--app-status-progress);
  font-weight: var(--app-font-weight-medium);
  text-decoration: underline;
  cursor: pointer;
  font-size: var(--app-font-size-13px);
  margin-top: 4px;
  position: relative;
  z-index: 2;
}

.rich-text-viewer--despacho .ver-mais-link {
  margin-top: 0;
}

.despacho-modal-conteudo {
  box-sizing: border-box;
  width: 100%;
  max-width: 21cm;
  margin: 0 auto;
  padding: clamp(16px, 4vw, 40px);
  border-radius: 2px;
  background: var(--app-white);
  color: var(--app-legacy-shortcut-text);
  font-size: var(--app-font-size-16px);
  line-height: 1.65;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

/* Listas com parênteses customizadas (a), A), i), I)) */
.rich-text-viewer-value ::ng-deep ol.rte-list-alpha-paren,
.despacho-modal-conteudo ::ng-deep ol.rte-list-alpha-paren,
.rich-text-viewer-value ::ng-deep ol.rte-list-upper-alpha-paren,
.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-alpha-paren,
.rich-text-viewer-value ::ng-deep ol.rte-list-lower-roman-paren,
.despacho-modal-conteudo ::ng-deep ol.rte-list-lower-roman-paren,
.rich-text-viewer-value ::ng-deep ol.rte-list-upper-roman-paren,
.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-roman-paren {
  list-style: none !important;
  counter-reset: paren-counter;
}
.rich-text-viewer-value ::ng-deep ol.rte-list-alpha-paren > li,
.despacho-modal-conteudo ::ng-deep ol.rte-list-alpha-paren > li,
.rich-text-viewer-value ::ng-deep ol.rte-list-upper-alpha-paren > li,
.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-alpha-paren > li,
.rich-text-viewer-value ::ng-deep ol.rte-list-lower-roman-paren > li,
.despacho-modal-conteudo ::ng-deep ol.rte-list-lower-roman-paren > li,
.rich-text-viewer-value ::ng-deep ol.rte-list-upper-roman-paren > li,
.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-roman-paren > li {
  counter-increment: paren-counter;
}
.rich-text-viewer-value ::ng-deep ol.rte-list-alpha-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-alpha-paren > li::before,
.rich-text-viewer-value ::ng-deep ol.rte-list-upper-alpha-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-alpha-paren > li::before,
.rich-text-viewer-value ::ng-deep ol.rte-list-lower-roman-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-lower-roman-paren > li::before,
.rich-text-viewer-value ::ng-deep ol.rte-list-upper-roman-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-roman-paren > li::before {
  display: inline-block;
  box-sizing: border-box;
  width: 1.5rem;
  margin-left: -1.5rem;
  padding-right: 0.1rem;
  text-align: right;
}
.rich-text-viewer-value ::ng-deep ol.rte-list-alpha-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-alpha-paren > li::before {
  content: counter(paren-counter, lower-alpha) ") ";
}
.rich-text-viewer-value ::ng-deep ol.rte-list-upper-alpha-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-alpha-paren > li::before {
  content: counter(paren-counter, upper-alpha) ") ";
}
.rich-text-viewer-value ::ng-deep ol.rte-list-lower-roman-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-lower-roman-paren > li::before {
  content: counter(paren-counter, lower-roman) ") ";
}
.rich-text-viewer-value ::ng-deep ol.rte-list-upper-roman-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-roman-paren > li::before {
  content: counter(paren-counter, upper-roman) ") ";
}

/* Listas numéricas com parêntese e ordinais (1), 1º, 1ª) */
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-paren,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-paren,
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordm,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordm,
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordf,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordf {
  list-style: none !important;
  counter-reset: paren-counter;
}
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-paren > li,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-paren > li,
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordm > li,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordm > li,
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordf > li,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordf > li {
  counter-increment: paren-counter;
}
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-paren > li::before,
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordm > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordm > li::before,
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordf > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordf > li::before {
  display: inline-block;
  box-sizing: border-box;
  width: 1.5rem;
  margin-left: -1.5rem;
  padding-right: 0.1rem;
  text-align: right;
}
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-paren > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-paren > li::before {
  content: counter(paren-counter) ") ";
}
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordm > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordm > li::before {
  content: counter(paren-counter) "º ";
}
.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordf > li::before,
.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordf > li::before {
  content: counter(paren-counter) "ª ";
}

.rich-text-viewer-value ::ng-deep .rte-list-separator,
.despacho-modal-conteudo ::ng-deep .rte-list-separator { height: 0; overflow: hidden; }

.despacho-modal-conteudo ::ng-deep p { margin: 0 0 0.75em; }
.despacho-modal-conteudo ::ng-deep ol,
.despacho-modal-conteudo ::ng-deep ul { margin: 0 0 0.75em; padding-left: 1.5em; }

:host {
  display: block;
  --rich-text-collapsed-height: 80px;
  --rich-text-expanded-height: 240px;
}

.rich-text-viewport {
  position: relative;
  overflow: hidden;
  transition: max-height 280ms ease-in-out;
}

.rich-text-viewport:not(.rich-text-measured) {
  max-height: var(--rich-text-collapsed-height);
}

@media (max-width: 640px) {
  :host {
    --rich-text-collapsed-height: 64px;
    --rich-text-expanded-height: 180px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .rich-text-viewport { transition: none; }
}

.despacho-label {
  display: flex;
  align-items: center;
  gap: 2px;
}


:host-context(.excluded) .despacho-label {
  color: var(--app-timeline-excluded);
}

.rich-text-viewport.is-collapsed { max-height: var(--rich-text-collapsed-height); }
.rich-text-viewport.is-expanded { max-height: var(--rich-text-expanded-height); }

:host-context(.excluded) .rich-text-viewer-value { color: var(--app-timeline-excluded); }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/rich-text-viewer/rich-text-viewer.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yEAAyE;EACzE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,0CAA0C;EAC1C,0BAA0B;EAC1B,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,oCAAoC;EACpC,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;;;;;;;;EAQE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;;;;;;;;EAQE,gCAAgC;AAClC;AACA;;;;;;;;EAQE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;;AAEA,2DAA2D;AAC3D;;;;;;EAME,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;;;;;;EAME,gCAAgC;AAClC;AACA;;;;;;EAME,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;;AAEA;yDACyD,SAAS,EAAE,gBAAgB,EAAE;;AAEtF,uCAAuC,kBAAkB,EAAE;AAC3D;wCACwC,kBAAkB,EAAE,mBAAmB,EAAE;;AAEjF;EACE,cAAc;EACd,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,kCAAkC;IAClC,kCAAkC;EACpC;AACF;;AAEA;EACE,sBAAsB,gBAAgB,EAAE;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;;AAGA;EACE,mCAAmC;AACrC;;AAEA,mCAAmC,6CAA6C,EAAE;AAClF,kCAAkC,4CAA4C,EAAE;;AAEhF,mDAAmD,mCAAmC,EAAE","sourcesContent":[":host(.rich-text-viewer--with-files) .despacho-box {\n  margin-bottom: 0;\n}\n\n.despacho-box {\n  background-color: var(--app-slate-100);\n  border-radius: 6px;\n  padding: 4px 8px;\n  margin-top: 2px;\n  margin-bottom: 4px;\n}\n\n.rich-text-viewer-value {\n  display: flow-root;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.rich-text-viewer-value ::ng-deep p {\n  margin: 0;\n}\n\n.rich-text-viewer-value ::ng-deep ul,\n.rich-text-viewer-value ::ng-deep ol {\n  margin: 0;\n  padding-left: 1.2em;\n}\n\n.rich-text-viewer--despacho .rich-text-viewer-value ::ng-deep ul,\n.rich-text-viewer--despacho .rich-text-viewer-value ::ng-deep ol {\n  padding: 0 0 0 1em;\n}\n\n.despacho-preview::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 35px;\n  background: linear-gradient(to bottom, transparent, var(--app-slate-100));\n  pointer-events: none;\n}\n\n.ver-mais-link {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  color: var(--app-status-progress);\n  font-weight: var(--app-font-weight-medium);\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: var(--app-font-size-13px);\n  margin-top: 4px;\n  position: relative;\n  z-index: 2;\n}\n\n.rich-text-viewer--despacho .ver-mais-link {\n  margin-top: 0;\n}\n\n.despacho-modal-conteudo {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 21cm;\n  margin: 0 auto;\n  padding: clamp(16px, 4vw, 40px);\n  border-radius: 2px;\n  background: var(--app-white);\n  color: var(--app-legacy-shortcut-text);\n  font-size: var(--app-font-size-16px);\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n\n/* Listas com parênteses customizadas (a), A), i), I)) */\n.rich-text-viewer-value ::ng-deep ol.rte-list-alpha-paren,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-alpha-paren,\n.rich-text-viewer-value ::ng-deep ol.rte-list-upper-alpha-paren,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-alpha-paren,\n.rich-text-viewer-value ::ng-deep ol.rte-list-lower-roman-paren,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-lower-roman-paren,\n.rich-text-viewer-value ::ng-deep ol.rte-list-upper-roman-paren,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-roman-paren {\n  list-style: none !important;\n  counter-reset: paren-counter;\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-alpha-paren > li,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-alpha-paren > li,\n.rich-text-viewer-value ::ng-deep ol.rte-list-upper-alpha-paren > li,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-alpha-paren > li,\n.rich-text-viewer-value ::ng-deep ol.rte-list-lower-roman-paren > li,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-lower-roman-paren > li,\n.rich-text-viewer-value ::ng-deep ol.rte-list-upper-roman-paren > li,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-roman-paren > li {\n  counter-increment: paren-counter;\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-alpha-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-alpha-paren > li::before,\n.rich-text-viewer-value ::ng-deep ol.rte-list-upper-alpha-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-alpha-paren > li::before,\n.rich-text-viewer-value ::ng-deep ol.rte-list-lower-roman-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-lower-roman-paren > li::before,\n.rich-text-viewer-value ::ng-deep ol.rte-list-upper-roman-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-roman-paren > li::before {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 1.5rem;\n  margin-left: -1.5rem;\n  padding-right: 0.1rem;\n  text-align: right;\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-alpha-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-alpha-paren > li::before {\n  content: counter(paren-counter, lower-alpha) \") \";\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-upper-alpha-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-alpha-paren > li::before {\n  content: counter(paren-counter, upper-alpha) \") \";\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-lower-roman-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-lower-roman-paren > li::before {\n  content: counter(paren-counter, lower-roman) \") \";\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-upper-roman-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-upper-roman-paren > li::before {\n  content: counter(paren-counter, upper-roman) \") \";\n}\n\n/* Listas numéricas com parêntese e ordinais (1), 1º, 1ª) */\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-paren,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-paren,\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordm,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordm,\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordf,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordf {\n  list-style: none !important;\n  counter-reset: paren-counter;\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-paren > li,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-paren > li,\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordm > li,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordm > li,\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordf > li,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordf > li {\n  counter-increment: paren-counter;\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-paren > li::before,\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordm > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordm > li::before,\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordf > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordf > li::before {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 1.5rem;\n  margin-left: -1.5rem;\n  padding-right: 0.1rem;\n  text-align: right;\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-paren > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-paren > li::before {\n  content: counter(paren-counter) \") \";\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordm > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordm > li::before {\n  content: counter(paren-counter) \"º \";\n}\n.rich-text-viewer-value ::ng-deep ol.rte-list-decimal-ordf > li::before,\n.despacho-modal-conteudo ::ng-deep ol.rte-list-decimal-ordf > li::before {\n  content: counter(paren-counter) \"ª \";\n}\n\n.rich-text-viewer-value ::ng-deep .rte-list-separator,\n.despacho-modal-conteudo ::ng-deep .rte-list-separator { height: 0; overflow: hidden; }\n\n.despacho-modal-conteudo ::ng-deep p { margin: 0 0 0.75em; }\n.despacho-modal-conteudo ::ng-deep ol,\n.despacho-modal-conteudo ::ng-deep ul { margin: 0 0 0.75em; padding-left: 1.5em; }\n\n:host {\n  display: block;\n  --rich-text-collapsed-height: 80px;\n  --rich-text-expanded-height: 240px;\n}\n\n.rich-text-viewport {\n  position: relative;\n  overflow: hidden;\n  transition: max-height 280ms ease-in-out;\n}\n\n.rich-text-viewport:not(.rich-text-measured) {\n  max-height: var(--rich-text-collapsed-height);\n}\n\n@media (max-width: 640px) {\n  :host {\n    --rich-text-collapsed-height: 64px;\n    --rich-text-expanded-height: 180px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rich-text-viewport { transition: none; }\n}\n\n.despacho-label {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n\n:host-context(.excluded) .despacho-label {\n  color: var(--app-timeline-excluded);\n}\n\n.rich-text-viewport.is-collapsed { max-height: var(--rich-text-collapsed-height); }\n.rich-text-viewport.is-expanded { max-height: var(--rich-text-expanded-height); }\n\n:host-context(.excluded) .rich-text-viewer-value { color: var(--app-timeline-excluded); }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
